import React, { Component } from "react";
import {
  Route,
  Redirect,
  BrowserRouter as Router,
  Switch,
} from "react-router-dom";
import { connect } from "react-redux";
import to from "await-to-js";

import {
  loadCountries,
  loadDistricts,
  loadPostCodes,
  loadProvinces,
  loadSubDistricts,
} from "./components/helpers/address";

import { setInitialAddressData } from "./stores/actions";

import SplashScreen from "./pages/splashscreen/SplashScreen";
import Notfound from "./pages/notfound/NotFound";

import Fatca from "./pages/fatca/Fatca";
import KtbstIDCDetail from "./pages/ktbst_idc_detail/KtbstIDCDetail";
import CheckUserInfo from "./pages/checkuserinfo/CheckUserInfo";
import KtbstOTP from "./pages/ktbst_otp/KtbstOTP";
import SplashScreenOa from "./pages/splashscreenoa/SplashscreenOa";
import PreRegis from "./pages/preregis/PreRegis";
import TermAndCon from "./pages/termandcon/TermAndCon";
import CheckAmerican from "./pages/checkamerican/CheckAmerican";
import SnapIdCard from "./pages/snapidcard/SnapIdCard";
import SnapIdCardOk from "./pages/snapidcard_ok/SnapIdCardOk";
import SnapFrontId from "./pages/snapfrontid/SnapFrontId";
import SnapFrontId2 from "./pages/snapfrontid/SnapFrontId2";
import SnapFrontId3 from "./pages/snapfrontid/SnapFrontId3";
import SnapBackId from "./pages/snapbackid/SnapBackId";
import KtbstTCNDID from "./pages/ktbst_tc_ndid/KtbstTCNDID";
import KtbstNDID from "./pages/ktbst_ndid/KtbstNDID";
import KtbstNDIDChoice from "./pages/ktbst_ndid_choice/KtbstNDIDChoice";
import SummaryShow from "./pages/summaryshow/SummaryShow";
import TcConfirm from "./pages/tcconfirm/TcConfirm";
import Pdpa from "./pages/pdpa/Pdpa";
import FamilyStatus from "./pages/familystatus/FamilyStatus";
import FamilyStatusSingle from "./pages/familystatussingle/FamilyStatusSingle";
import StatusChildren from "./pages/statusChildren/StatusChildren";
import LegelAgeChildren from "./pages/legal_age_children/LegelAgeChildren";
import EmergencyContact from "./pages/emergency_contact/EmergencyContact";
import PoliticianRelation from "./pages/politician_relation/PoliticianRelation";
import FinancialDetail from "./pages/financial_detail/FinancialDetail";
import KtbstIDCAddressChoose from "./pages/ktbst_idc_address_choose/KtbstIDCAddressChoose";
import KtbstIDCAddressChoose2 from "./pages/ktbst_idc_address_choose2/KtbstIDCAddressChoose2";
import KtbstIDCAddressForm from "./pages/ktbst_idc_address_form/KtbstIDCAddressForm";
import KtbstRisk from "./pages/ktbst_risk/KtbstRisk";
import KtbstRiskQuestion from "./pages/ktbst_risk_question/KtbstRiskQuestion";
import KtbstRiskPoll from "./pages/ktbst_risk_poll/KtbstRiskPoll";
import KtbstRiskPoll2 from "./pages/ktbst_risk_poll/KtbstRiskPoll2";
import KtbstRiskPoll3 from "./pages/ktbst_risk_poll/KtbstRiskPoll3";
import KtbstSummaryRisk from "./pages/ktbst_summary_risk/KtbstSummaryRisk";
import KtbstInvestmentObjective from "./pages/ktbst_Investment_objective/KtbstInvestmentObjective";
import Jobs from "./pages/jobs/Jobs";
import KtbstInvestmentInfoIncome from "./pages/ktbst_investment_info_income/KtbstInvestmentInfoIncome";
import KtbstInvestmentInfoList from "./pages/ktbst_investment_info_list/KtbstInvestmentInfoList";
import KtbstInvestmentInfoList2 from "./pages/ktbst_investment_info_list2/KtbstInvestmentInfoList2";
import KtbstValueOfInvester from "./pages/ktbst_value_of_lnvester/KtbstValueOfInvester";
import KtbstATSChoice from "./pages/ktbst_ats_choice/KtbstATSChoice";
import KtbstATSChoiceOther from "./pages/ktbst_ats_choice_other/KtbstATSChoiceOther";
import KtbstSigneEx from "./pages/ktbst_signed_attatched/KtbstSigneEx";
import KtbstSignedAttatched from "./pages/ktbst_signed_attatched/KtbstSignedAttatched";
import KtbstSignedAttatchedOK from "./pages/ktbst_signed_attatched_ok/KtbstSignedAttatchedOK";
import KtbstSignSignatureHorizonScreen from "./pages/ktbst_sign_signature_horizonscreen/KtbstSignSignatureHorizonScreen";
import KtbstNdidIdpRepons from "./pages/ktbst_ndid_idp_repons/KtbstNdidIdpRepons";
import ATS from "./pages/ats/ATS";
import ATS_CALLBACK from "./pages/ats_callback/ATS_CALLBACK";
import Iframe from "./pages/iframe/Iframe";
import ATSForm from "./pages/ats_form/ATSForm";
import Clear_data from "./pages/clear_data/Clear_data";
import LoginDesktop from "./pages/login/LoginDesktop";
import securities from "./pages/ktbst_summary_risk/securities";
import KtbstBrowserSuitable from "./pages/ktbst_browser_suitable/KtbstBrowserSuitable";
import ProductChoice from "./pages/product_choice/Product_choice";
import ProductConsent from "./pages/product_consent/Product_consent";
import Ndid_info from "./pages/ndid_info/Ndid_info";
import NdidOffline from "./pages/ndid_offline/NdidOffline";
import NdidTC from "./pages/ndid_offline/NdidOffineTC";
import NdidList from "./pages/ndid_offline/NdidOfflineList";
import NdidChoice from "./pages/ndid_offline/NdidOfflineChoice";
import CrsBirthAddress from "./pages/crs_birth_address/crs_birth_address";
import CrsDeclareLocation from "./pages/crs_declare_location/crs_declare_location";
import CrsDeclareLocationForm from "./pages/crs_declare_location_form/crs_declare_location_form";
import CrsConsent from "./pages/crs_consent/crs_consent";
import DipchipWaiting from "./pages/EKYC/DipchipWaiting";
import EkycList from "./pages/EKYC/EkycList";
import HouseRegistration from "./pages/HouseRegistration/HouseRegistration";

import ProtectedRoute from "./hooks/ProtectedRoute";
class AppRouter extends Component {
  constructor(props) {
    super(props);
    const identifier = localStorage.getItem("identifier");
    this.state = {
      identifier: identifier,
    };
  }

  async componentDidMount() {
    const [error, result] = await to(
      Promise.all([
        loadCountries(),
        loadProvinces(),
        loadDistricts(),
        loadSubDistricts(),
        loadPostCodes(),
      ]),
    );
    if (!error && result) {
      const [countries, provinces, districts, subdistricts, postcodes] = result;

      if (countries && provinces && districts && subdistricts && postcodes) {
        this.props.setInitialAddressData({
          countries,
          provinces,
          districts,
          subdistricts,
          postcodes,
        });
      }
    } else {
      console.log(error);
    }

    // Remove splash screen
    const splashScreen = document.querySelector(".app-splash-screen");
    if (splashScreen) {
      splashScreen.style.opacity = 0;
      setTimeout(() => {
        splashScreen && splashScreen.parentNode.removeChild(splashScreen);
      }, 500);
    }
  }

  isLoadAddress() {
    const { countries, provinces, districts, subdistricts, postcodes } =
      this.props.address;
    return (
      countries.length > 0 &&
      provinces.length > 0 &&
      districts.length > 0 &&
      subdistricts.length > 0 &&
      postcodes.length > 0
    );
  }

  render() {
    const { address } = this.props;

    return (
      <Router>
        <Switch>
          <Redirect exact from="/" to="/index.html" />

          {/* Public - ไม่เช็ค */}
          <Route path="/desktop_ktbst" component={LoginDesktop} />
          <Route path="/splashscreen" component={SplashScreen} />
          <Route path="/index.html" component={SplashScreenOa} />
          <ProtectedRoute path="/tcconfirm" component={TcConfirm} />
          <Route
            path="/ktbst_browser_suitable"
            component={KtbstBrowserSuitable}
          />
          <Route path="/clear_data" component={Clear_data} />

          {/* Protected - เช็ค confirm */}
          <Route path="/preregis" component={PreRegis} />
          <Route path="/termandcon" component={TermAndCon} />
          <ProtectedRoute path="/checkamerican" component={CheckAmerican} />
          <ProtectedRoute path="/summaryshow" component={SummaryShow} />
          <Route path="/pdpa" component={Pdpa} />

          <ProtectedRoute path="/fatca" component={Fatca} />
          <ProtectedRoute path="/idc_detail" component={KtbstIDCDetail} />
          <ProtectedRoute path="/otp" component={KtbstOTP} />
          <ProtectedRoute
            path="/house_registration"
            component={HouseRegistration}
          />
          <ProtectedRoute
            path="/ndid_choice/:BankID"
            render={(props) =>
              this.state.identifier ? (
                <NdidChoice {...props} address={address} />
              ) : (
                <KtbstNDIDChoice {...props} address={address} />
              )
            }
          />
          <ProtectedRoute
            path="/idc_address_choose"
            render={(props) =>
              this.isLoadAddress() && (
                <KtbstIDCAddressChoose {...props} address={address} />
              )
            }
          />
          <ProtectedRoute
            path="/idc_address_choose2"
            render={(props) =>
              this.isLoadAddress() && (
                <KtbstIDCAddressChoose2 {...props} address={address} />
              )
            }
          />
          <ProtectedRoute
            path="/idc_address_form"
            render={(props) =>
              this.isLoadAddress() && (
                <KtbstIDCAddressForm {...props} address={address} />
              )
            }
          />
          <ProtectedRoute path="/risk" component={KtbstRisk} />
          <ProtectedRoute path="/risk_question" component={KtbstRiskQuestion} />
          <ProtectedRoute path="/risk" component={KtbstRisk} />
          <ProtectedRoute path="/risk_question" component={KtbstRiskQuestion} />
          <ProtectedRoute path="/risk_poll" component={KtbstRiskPoll} />
          <ProtectedRoute path="/risk_poll2" component={KtbstRiskPoll2} />
          <ProtectedRoute path="/risk_poll3" component={KtbstRiskPoll3} />
          <ProtectedRoute path="/summary_risk" component={KtbstSummaryRisk} />
          <ProtectedRoute path="/ats_choice" component={KtbstATSChoice} />
          <ProtectedRoute
            path="/ats_choice_other"
            component={KtbstATSChoiceOther}
          />
          <ProtectedRoute
            path="/investment_objective"
            component={KtbstInvestmentObjective}
          />
          <ProtectedRoute
            path="/investment_info_income"
            component={KtbstInvestmentInfoIncome}
          />
          <ProtectedRoute
            path="/investment_info_list"
            component={KtbstInvestmentInfoList}
          />
          <ProtectedRoute
            path="/investment_info_list_2"
            component={KtbstInvestmentInfoList2}
          />
          <ProtectedRoute
            path="/value_of_invester"
            component={KtbstValueOfInvester}
          />
          <ProtectedRoute
            path="/signed_attatched"
            component={KtbstSignedAttatched}
          />
          <ProtectedRoute
            path="/signed_attatched_ex"
            component={KtbstSigneEx}
          />
          <ProtectedRoute
            path="/signed_attatched_ok"
            component={KtbstSignedAttatchedOK}
          />
          <ProtectedRoute
            path="/ktbst_sign_signature_horizonscreen"
            component={KtbstSignSignatureHorizonScreen}
          />
          <ProtectedRoute
            path="/ktbst_ndid_idp_repons"
            component={KtbstNdidIdpRepons}
          />
          <ProtectedRoute path="/CheckUserInfo" component={CheckUserInfo} />
          <ProtectedRoute path="/SnapIdCard" component={SnapIdCard} />
          <ProtectedRoute path="/SnapIdCard_ok" component={SnapIdCardOk} />
          <ProtectedRoute path="/SnapFrontId" component={SnapFrontId} />
          <ProtectedRoute path="/SnapFrontId2" component={SnapFrontId2} />
          <ProtectedRoute path="/SnapFrontId3" component={SnapFrontId3} />
          <ProtectedRoute path="/SnapBackId" component={SnapBackId} />
          <ProtectedRoute path="/FamilyStatus" component={FamilyStatus} />
          <ProtectedRoute
            path="/FamilyStatusSingle"
            component={FamilyStatusSingle}
          />
          <ProtectedRoute path="/StatusChildren" component={StatusChildren} />
          <ProtectedRoute
            path="/LegelAgeChildren"
            component={LegelAgeChildren}
          />
          <ProtectedRoute
            path="/EmergencyContact"
            component={EmergencyContact}
          />
          <ProtectedRoute
            path="/PoliticianRelation"
            component={PoliticianRelation}
          />
          <ProtectedRoute path="/FinancialDetail" component={FinancialDetail} />
          <ProtectedRoute path="/Jobs" component={Jobs} />
          <ProtectedRoute path="/ats" component={ATS} />
          <ProtectedRoute path="/ats_callback" component={ATS_CALLBACK} />
          <ProtectedRoute path="/ats_form" component={ATSForm} />
          <ProtectedRoute path="/iframe" component={Iframe} />
          <ProtectedRoute path="/securities" component={securities} />
          <ProtectedRoute path="/product_choice" component={ProductChoice} />
          <ProtectedRoute path="/product_consent" component={ProductConsent} />
          <ProtectedRoute path="/ndid_info" component={Ndid_info} />
          <ProtectedRoute path="/tc_ndid" component={KtbstTCNDID} />
          <ProtectedRoute path="/ndid" component={KtbstNDID} />
          <ProtectedRoute path="/ndid_tc" component={NdidTC} />
          <ProtectedRoute path="/ndid_offline" component={NdidOffline} />
          <ProtectedRoute path="/ndid_list" component={NdidList} />
          <ProtectedRoute
            path="/crs_birth_address"
            component={CrsBirthAddress}
          />
          <ProtectedRoute
            path="/crs_declare_location"
            component={CrsDeclareLocation}
          />
          <ProtectedRoute
            path="/crs_declare_location_form"
            component={CrsDeclareLocationForm}
          />
          <ProtectedRoute path="/crs_consent" component={CrsConsent} />
          <ProtectedRoute path="/ekyc_list" component={EkycList} />
          <ProtectedRoute path="/dipchip_waiting" component={DipchipWaiting} />

          <Route component={Notfound} />
        </Switch>
      </Router>
    );
  }
}

const mapStateToProps = (state) => ({
  address: state.address,
});

const mapDispatchToProps = (dispatch) => ({
  setInitialAddressData: (value) => dispatch(setInitialAddressData(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppRouter);
